import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Flex, Box } from "@chakra-ui/react";
import { FilterUserProps, IFilterUser } from "./interface";
import FieldSearch from "../FieldSearch";
import { getQuotationStatusName } from "../../helpers/global";
import CustomReactSelect from "../CustomReactSelect";
import { QuotationStatus } from "../../generated/graphql";

const Filter: React.FC<FilterUserProps> = ({ onSubmit, value }) => {
  const { handleSubmit, setValue, control } = useForm<IFilterUser>();

  useEffect(() => {
    setValue("key", value?.key || "");
  }, [value, setValue]);

  return (
    <form onSubmit={(e) => e.preventDefault()} autoComplete="off">
      <Flex alignItems="center" gap={4}>
        <Box>
          <Controller
            name="key"
            control={control}
            render={({ field: { onChange, value } }) => (
              <FieldSearch
                placeholder="Search User"
                value={value}
                onChange={(e) => {
                  onChange(e);
                  handleSubmit(onSubmit)();
                }}
              />
            )}
          />
        </Box>
      </Flex>
    </form>
  );
};

export default Filter;
